import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex-grow-1 table-responsive" }
const _hoisted_2 = { class: "table mb-0" }
const _hoisted_3 = { class: "h5 text-end text-nowrap" }
const _hoisted_4 = { class: "h6 text-end" }
const _hoisted_5 = { class: "h6 text-end" }
const _hoisted_6 = { class: "h6 text-end text-nowrap" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = {
  key: 0,
  class: "fas fa-award text-yellow fa-lg"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "scholarship-stack" }
const _hoisted_12 = { class: "scholarship-stack" }
const _hoisted_13 = { class: "scholarship-stack" }
const _hoisted_14 = { class: "small" }
const _hoisted_15 = { class: "small fw-bold" }
const _hoisted_16 = { class: "small text-center" }
const _hoisted_17 = { colspan: "2" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-6 col-md-4" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "text-nowrap" }
const _hoisted_22 = {
  key: 0,
  class: "fas fa-times-circle text-red"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "text-nowrap" }
const _hoisted_25 = {
  key: 0,
  class: "fas fa-times-circle text-red"
}
const _hoisted_26 = { class: "col-6 col-md-4" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = {
  key: 0,
  class: "fas fa-check-circle text-success fa-lg mt-1"
}
const _hoisted_29 = {
  key: 1,
  class: "fas fa-times-circle text-red fa-lg mt-1"
}
const _hoisted_30 = { class: "col-12 col-md-4" }
const _hoisted_31 = { class: "text-nowrap" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 0,
  class: "fas fa-times-circle text-red"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 0,
  class: "fas fa-times-circle text-red"
}
const _hoisted_36 = {
  key: 0,
  class: "bg-table-footer"
}
const _hoisted_37 = {
  key: 0,
  class: "bg-gradient"
}
const _hoisted_38 = { class: "h6 small text-end" }
const _hoisted_39 = {
  key: 1,
  class: "bg-gradient"
}
const _hoisted_40 = { class: "h6 small text-end fw-bold" }
const _hoisted_41 = {
  key: 2,
  class: "bg-gradient small"
}
const _hoisted_42 = { class: "h6 small" }
const _hoisted_43 = { class: "ms-1 fw-bold" }
const _hoisted_44 = { class: "h6 small text-end" }
const _hoisted_45 = { class: "ms-1 fw-bold" }
const _hoisted_46 = {
  key: 3,
  class: "bg-gradient"
}
const _hoisted_47 = { class: "h6 small text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rank_icon = _resolveComponent("rank-icon")!
  const _component_package_icon = _resolveComponent("package-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _cache[0] || (_cache[0] = _createElementVNode("td", null, null, -1)),
          _cache[1] || (_cache[1] = _createElementVNode("td", { class: "h5" }, "Rango actual:", -1)),
          _createElementVNode("td", _hoisted_3, [
            _createVNode(_component_rank_icon, {
              "icon-class": _ctx.userRank?.iconClass,
              "extra-class": "pe-2"
            }, null, 8, ["icon-class"]),
            _createTextVNode(" " + _toDisplayString(_ctx.userRank?.name), 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("td", null, null, -1))
        ]),
        _createElementVNode("tr", null, [
          _cache[3] || (_cache[3] = _createElementVNode("td", null, null, -1)),
          _cache[4] || (_cache[4] = _createElementVNode("td", { class: "h6" }, "Volumen Calificado:", -1)),
          _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.totalValidPoints.toLocaleString()), 1),
          _cache[5] || (_cache[5] = _createElementVNode("td", null, null, -1))
        ]),
        _createElementVNode("tr", null, [
          _cache[6] || (_cache[6] = _createElementVNode("td", null, null, -1)),
          _cache[7] || (_cache[7] = _createElementVNode("td", { class: "h6" }, "Volumen Total:", -1)),
          _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.userData.points.current.toLocaleString()), 1),
          _cache[8] || (_cache[8] = _createElementVNode("td", null, null, -1))
        ]),
        _createElementVNode("tr", null, [
          _cache[9] || (_cache[9] = _createElementVNode("td", null, null, -1)),
          _cache[10] || (_cache[10] = _createElementVNode("td", { class: "h6" }, "Total facturado por la red:", -1)),
          _createElementVNode("td", _hoisted_6, "G$ " + _toDisplayString(_ctx.invoicedTotalString), 1),
          _cache[11] || (_cache[11] = _createElementVNode("td", null, null, -1))
        ]),
        (_ctx.userData.scholarshipData)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
              _cache[12] || (_cache[12] = _createElementVNode("td", null, null, -1)),
              _cache[13] || (_cache[13] = _createElementVNode("td", null, [
                _createElementVNode("i", { class: "fas fa-piggy-bank fa-fw me-2" }),
                _createTextVNode("Beca GTR Evolution "),
                _createElementVNode("div", { class: "small" }, [
                  _createElementVNode("i", { class: "fas fa-fw me-2" }),
                  _createTextVNode(" Fin del Periodo: ")
                ])
              ], -1)),
              _createElementVNode("td", _hoisted_8, [
                (_ctx.userData.scholarshipData.periodPoints >= 300)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, [
                        (
                    _ctx.userData.scholarshipData.periodPoints > 0 &&
                    _ctx.userData.scholarshipData.periodPoints < 100
                  )
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: _normalizeClass([_ctx.scholarshipPointsClass(100), "text-orange"])
                            }, null, 2))
                          : _createCommentVNode("", true),
                        _createElementVNode("i", {
                          class: _normalizeClass(_ctx.scholarshipPointsClass(100)),
                          style: _normalizeStyle(_ctx.scholarshipPartialPercentageStyle(100))
                        }, null, 6)
                      ]),
                      _createElementVNode("span", _hoisted_12, [
                        (
                    _ctx.userData.scholarshipData.periodPoints > 100 &&
                    _ctx.userData.scholarshipData.periodPoints < 200
                  )
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: _normalizeClass([_ctx.scholarshipPointsClass(200), "text-orange"])
                            }, null, 2))
                          : _createCommentVNode("", true),
                        _createElementVNode("i", {
                          class: _normalizeClass(_ctx.scholarshipPointsClass(200)),
                          style: _normalizeStyle(_ctx.scholarshipPartialPercentageStyle(200))
                        }, null, 6)
                      ]),
                      _createElementVNode("span", _hoisted_13, [
                        (
                    _ctx.userData.scholarshipData.periodPoints > 200 &&
                    _ctx.userData.scholarshipData.periodPoints < 300
                  )
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: _normalizeClass([_ctx.scholarshipPointsClass(300), "text-orange"])
                            }, null, 2))
                          : _createCommentVNode("", true),
                        _createElementVNode("i", {
                          class: _normalizeClass(_ctx.scholarshipPointsClass(300)),
                          style: _normalizeStyle(_ctx.scholarshipPartialPercentageStyle(300))
                        }, null, 6)
                      ])
                    ])),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.scholarshipEndDate), 1)
                ])
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("td", null, null, -1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("tr", _hoisted_16, [
          _cache[19] || (_cache[19] = _createElementVNode("td", null, null, -1)),
          _createElementVNode("td", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_ctx.isAcademyLevel)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_package_icon, {
                          product: _ctx.currentUserPackage,
                          "extra-class": "me-2"
                        }, null, 8, ["product"]),
                        _cache[15] || (_cache[15] = _createTextVNode(" Academia ", -1))
                      ]),
                      (_ctx.academyDaysLeft == undefined)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(["badge rounded-pill", _ctx.daysLeftClass(_ctx.academyDaysLeft)])
                          }, _toDisplayString(_ctx.academyDaysLeft?.toLocaleString()), 3))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isLiteLevel)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_package_icon, {
                          product: _ctx.currentUserPackage,
                          "extra-class": "me-2"
                        }, null, 8, ["product"]),
                        _cache[16] || (_cache[16] = _createTextVNode(" GTR Go ", -1))
                      ]),
                      (_ctx.gtrLiteDaysLeft == undefined)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(["badge rounded-pill", _ctx.daysLeftClass(_ctx.gtrLiteDaysLeft)])
                          }, _toDisplayString(_ctx.gtrLiteDaysLeft?.toLocaleString()), 3))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[17] || (_cache[17] = _createElementVNode("div", null, [
                  _createElementVNode("i", { class: "fa fas fa-fire fa-fw me-2" }),
                  _createTextVNode(" Acelerador de Riqueza ")
                ], -1)),
                _createElementVNode("span", _hoisted_27, [
                  (_ctx.hasMMIColombia)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                    : (_openBlock(), _createElementBlock("span", _hoisted_29))
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_package_icon, {
                    product: "license",
                    "extra-class": "me-2"
                  }),
                  _cache[18] || (_cache[18] = _createTextVNode(" Lic. de Distribuidor ", -1))
                ]),
                (_ctx.isAcademyLevel)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                      (_ctx.distributorDaysLeft == undefined)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(["badge rounded-pill", _ctx.daysLeftClass(_ctx.distributorDaysLeft)])
                          }, _toDisplayString(_ctx.distributorDaysLeft?.toLocaleString()), 3))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isLiteLevel)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                      (_ctx.liteDistributorDaysLeft == undefined)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(["badge rounded-pill", _ctx.daysLeftClass(_ctx.liteDistributorDaysLeft)])
                          }, _toDisplayString(_ctx.liteDistributorDaysLeft?.toLocaleString()), 3))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("td", null, null, -1))
        ])
      ]),
      (_ctx.displayFooter)
        ? (_openBlock(), _createElementBlock("tfoot", _hoisted_36, [
            (_ctx.userNextRankId)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                  _cache[21] || (_cache[21] = _createElementVNode("td", null, null, -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("td", { class: "h6 small" }, "Siguiente Rango:", -1)),
                  _createElementVNode("td", _hoisted_38, [
                    _createVNode(_component_rank_icon, {
                      "icon-class": _ctx.userNextRank?.iconClass,
                      "extra-class": "pe-2"
                    }, null, 8, ["icon-class"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.rankName(_ctx.userNextRankId)), 1)
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("td", null, null, -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.nextRankPoints != '0')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                  _cache[24] || (_cache[24] = _createElementVNode("td", null, null, -1)),
                  _cache[25] || (_cache[25] = _createElementVNode("td", { class: "h6 small" }, " Volumen Calificado Requerido: ", -1)),
                  _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.nextRankPoints), 1),
                  _cache[26] || (_cache[26] = _createElementVNode("td", null, null, -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.nextRankPoints != '0')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                  _cache[27] || (_cache[27] = _createElementVNode("td", null, null, -1)),
                  _createElementVNode("td", _hoisted_42, [
                    _createTextVNode(" Máximo por Equipo (" + _toDisplayString(_ctx.maxTeamPercentage) + "%): ", 1),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.maxTeamPoints), 1)
                  ]),
                  _createElementVNode("td", _hoisted_44, [
                    _createTextVNode(" Máximo por Socio (" + _toDisplayString(_ctx.maxAffiliatePercentage) + "%): ", 1),
                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.maxAffiliatePoints), 1)
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("td", null, null, -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.nextRankEarning != '0.00')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                  _cache[29] || (_cache[29] = _createElementVNode("td", null, null, -1)),
                  _cache[30] || (_cache[30] = _createElementVNode("td", { class: "h6 small" }, " Ganancias requeridas: ", -1)),
                  _createElementVNode("td", _hoisted_47, "G$ " + _toDisplayString(_ctx.nextRankEarning), 1),
                  _cache[31] || (_cache[31] = _createElementVNode("td", null, null, -1))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}